import { FelaCSS } from '../../components/fela/flowtypes';
import { IStylingProps } from '../../themes/types';
import { TColor } from '../../types';
import IconWrap from './icon-wrap';

interface IProps extends IStylingProps {
  id?: string;
  color?: TColor;
  width?: number;
  style?: FelaCSS;
}

interface IconTypes {
  iconColor: string;
  width: number;
  height: number;
}

const IconReviewFilled = ({ id, color, width = 50, style, ...restProps }: IProps) => {
  const viewBoxWidth = 50;
  const viewBoxHeight = 48;

  const icon = ({ iconColor, width, height }: IconTypes) => (
    <svg
      id={id}
      viewBox={`0 0 ${viewBoxWidth} ${viewBoxHeight}`}
      width={`${width}px`}
      height={`${height}px`}>
      <path
        fill={iconColor}
        fillRule="evenodd"
        d="M39.254 47.999c-.31 0-.619-.074-.902-.224L25 40.718l-13.352 7.057a1.921 1.921 0 0 1-2.04-.148 1.953 1.953 0 0 1-.772-1.905l2.55-14.948L.586 20.19a1.956 1.956 0 0 1-.491-1.998 1.94 1.94 0 0 1 1.563-1.325l14.928-2.18 6.676-13.6a1.934 1.934 0 0 1 3.476-.001l6.676 13.6 14.928 2.18a1.94 1.94 0 0 1 1.563 1.325c.228.706.038 1.48-.49 1.998L38.614 30.774l2.55 14.948c.124.73-.175 1.47-.772 1.905a1.922 1.922 0 0 1-1.138.372z"
      />
    </svg>
  );

  return (
    <IconWrap
      icon={icon}
      color={color}
      width={width}
      viewBoxWidth={viewBoxWidth}
      viewBoxHeight={viewBoxHeight}
      style={style}
      {...restProps}
    />
  );
};

export default IconReviewFilled;
